import React, { useRef, useState } from "react";

import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { validaMonto, formatMoneda, seleccionarCampo } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import { Input, Select, Textarea } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";

export const IncluirMovimiento = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtIdMovimiento = useRef();
  const txtDescripcion = useRef();
  const txtFecha = useRef();
  const txtReferencia = useRef();
  const cmbTipoMovimiento = useRef();
  const txtMotivo = useRef();
  const txtMonto = useRef();

  const [body, setBody] = useState(null);
  const [operacion, setOperacion] = useState(0);
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const onChange = (e) => {
    if (e.target.name === "motivo") {
      e.target.value = e.target.value;
    } else {
      e.target.value = e.target.value;
    }
  };

  const onChangeValidar = () => {
    let sigue = true;

    if (cmbTipoMovimiento.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Tipo de Movimiento",
        icono: "informacion",
      });
      cmbTipoMovimiento.current.focus();
      sigue = false;
    } else if (txtFecha.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la Fecha",
        icono: "informacion",
      });
      txtFecha.current.focus();
      sigue = false;
    } else if (txtReferencia.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar la Referencia",
        icono: "informacion",
      });
      txtReferencia.current.focus();
      sigue = false;
    } else if (txtMotivo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Motivo de Movimiento",
        icono: "informacion",
      });
      txtMotivo.current.focus();
      sigue = false;
    } else if (
      txtMonto.current.value === "" ||
      txtMonto.current.value === "0,00"
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Monto de Movimiento",
        icono: "informacion",
      });
      txtMonto.current.focus();
      sigue = false;
    }

    if (sigue) {
      console.log("sigue");
      var movi = [];
      movi.push({
        idmovimientosentransito:
          txtIdMovimiento.current.value === ""
            ? 0
            : txtIdMovimiento.current.value,
        idcuentabancaria: props.idcuentabancaria,
        fecha: txtFecha.current.value,
        fechasis: fechasistema,
        referencia: txtReferencia.current.value.toUpperCase(),
        motivo: txtMotivo.current.value.toUpperCase(),
        monto:
          txtMonto.current.value !== ""
            ? parseFloat(
                txtMonto.current.value.replace(/\./g, "").replace(",", ".")
              )
            : "0.00",
        tipo: cmbTipoMovimiento.current.value,
        conciliado: "0",
      });

      setBody({
        movimiento: movi,
      });

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/contabilidadfis/actumovitran/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const blanquear = () => {
    setActivate(false);
    setBody(null);
    setHabilitado(false);
    txtIdMovimiento.current.value = "";
    cmbTipoMovimiento.current.value = "";
    txtFecha.current.value = "";
    txtReferencia.current.value = "";
    txtMotivo.current.value = "";
    txtMonto.current.value = "";
  };

  const cancelar = () => {
    props.onHideCancela();
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      setHabilitado(false);
      txtIdMovimiento.current.setAttribute("disabled", true);
      setTimeout(() => txtDescripcion.current.focus(), 200);
    } else if (op === 2) {
      txtIdMovimiento.current.removeAttribute("disabled");
      setHabilitado(false);
      txtIdMovimiento.current.focus();
    } else if (op === 3) {
      setHabilitado(true);
      txtIdMovimiento.current.removeAttribute("disabled");
      txtIdMovimiento.current.focus();
    } else if (op === 4) {
      setHabilitado(true);
      txtIdMovimiento.current.removeAttribute("disabled");
      txtIdMovimiento.current.focus();
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    } else if (op === 7) {
      cancelar();
    }
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.which === 13) {
      if (event.target.name === "fechadoc") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
        txtReferencia.current.focus();
      } else if (event.target.name === "refe") {
        txtMotivo.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.name === "fechadoc") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
      } else if (event.target.name === "fechaingre") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setHabilitado(props.habilitado);
        if (props.operacion === 1) {
          txtIdMovimiento.current.value = props.idmovimiento;
          txtIdMovimiento.current.focus();
        } else {
          txtIdMovimiento.current.value =
            props.registro.idmovimientosentransito;
          cmbTipoMovimiento.current.value = props.registro.tipo;

          txtFecha.current.value = moment.utc(props.registro.fecha).format(
            "YYYY-MM-DD"
          );
          txtReferencia.current.value = props.registro.referencia.trim();
          txtMotivo.current.value = props.registro.motivo.trim();
          txtMonto.current.value = formatMoneda(
            props.registro.monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold m-0">Incluir Movimiento.</h3>
        <a type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={cancelar}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-4 m-0 mb-2 p-0">
          <Input label = 'Id Movimiento:'
            disabled
            ref={txtIdMovimiento}
          />
        </div>
        <div className="col-5 m-0 mb-2 p-0 px-2">
          <Select label = 'Tipo Movimiento:'
            disabled={
              operacion === 1 ? false : operacion === 2 ? false : true
            }
            ref={cmbTipoMovimiento}
          >
            <option value="">--</option>
            <option value="0">Deposito</option>
            <option value="1">Transferencia</option>
            <option value="2">Nota Credito</option>
            <option value="3">Nota Debito</option>
            <option value="4">Cheque</option>
          </Select>
        </div>
        <div className="col-3 m-0 mb-2 p-0">
          <Input label = 'Fecha:'
            type="date"
            disabled={
              operacion === 1 ? false : operacion === 2 ? false : true
            }
            defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
            name="fechadoc"
            onKeyUp={handleInputChange}
            onBlur={handleInputChange}
            ref={txtFecha}
          />
        </div>
        <div className="col-4 m-0 mb-2 p-0">
          <Input label = 'Referencia:'
            disabled={
              operacion === 1 ? false : operacion === 2 ? false : true
            }
            name="refe"
            onKeyUp={handleInputChange}
            onBlur={handleInputChange}
            ref={txtReferencia}
          />
        </div>
        <div className="col-12 m-0 mb-2 p-0">
          <Textarea label = 'Motivo:'
            disabled={
              operacion === 1 ? false : operacion === 2 ? false : true
            }
            name="motivo"
            onChange={onChange}
            style={{ height: 60 }}
            ref={txtMotivo}
          />
        </div>
        <div className="col-4 m-0 p-0">
          <Input label = 'Monto:'
            defaultValue={"0,00"}
            disabled={
              operacion === 1 ? false : operacion === 2 ? false : true
            }
            onFocus={seleccionarCampo}
            onKeyUp={handleInputMontoChange}
            onBlur={handleInputMontoChange}
            ref={txtMonto}
          />
        </div>
      </Modal.Body>
      <Modal.Footer >
          <SuccessButton
            disabled={operacion === 4 ? true : false}
            onClick={onBotones(5)}
            ref={btnAcepta}
          >
              Aceptar
          </SuccessButton>
          <DangerButton
            ref={btnSalir}
            onClick={onBotones(7)}
          >
              Cancelar
          </DangerButton>
      </Modal.Footer>
      <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate}></Dimmer>
    </Modal>
  );
};
